<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <!-- <div *ngIf="data$ | async as fuelTypes"> -->
        <div style="page-break-inside: avoid">
            <h5>{{ title }}</h5>
            <table class="optionalComponentSectionTable">
                <tr style="font-weight: bold;">
                    <td>{{ title }}</td>
                    <td>Technologies</td>
                </tr>
                <tr *ngFor="let fuelType of fuelTypes">
                    <td style="padding:5px;">
                        {{ fuelType.powerFuelType }}
                    </td>
                    <td>
                        <table cellspacing="0" cellpadding="0">
                            <tr *ngFor="let technology of fuelType.technologyTypes">
                                <td style="border-width:0;">
                                    {{ technology }}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    <!-- </div> -->
</ng-template>

<ng-template #template_mobile let-title="title">
    <!-- <div *ngIf="data$ | async as fuelTypes"> -->
        <div style="page-break-inside: avoid">
            <h5>{{ title }}</h5>
            <div *ngFor="let fuelType of fuelTypes" class="optionalComponentSectionTable">
                <div>
                    <span style="font-weight:bold">Fuel Type: </span>
                    <span>{{ fuelType.powerFuelType }}</span>
                </div>
                <div>
                    <span style="font-weight:bold">Technologies: </span>
                    <ul>
                        <li *ngFor="let technology of fuelType.technologyTypes">{{ technology }}</li>
                    </ul>
                </div>
            </div>
        </div>
    <!-- </div> -->
</ng-template>